'use es6';

export var getWebsiteGrade = function getWebsiteGrade(state) {
  return state.grader;
};
export var getDomain = function getDomain(state) {
  return getWebsiteGrade(state).get('domain');
};